import PropTypes from 'prop-types';
import React from 'react';

import ErrorMessage from './ErrorMessage';
import { trackError } from '../modules/matomo';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo)
    trackError(error);
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <>
          <h1>Fehler</h1>
          <ErrorMessage error={error} />
        </>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

ErrorBoundary.defaultProps = {
  children: null,
};

export default ErrorBoundary;
